import { z } from 'zod'

export const MEMBERSHIP_PHASE2_READINESS_CONTRACT_VERSION = '1.0.0' as const

export const membershipPhase2ReadinessResponseSchema = z.record(z.unknown())

export type MembershipPhase2ReadinessResponse = z.infer<typeof membershipPhase2ReadinessResponseSchema>
